import { __assign, __rest } from 'tslib';
import MuiAvatar from '@mui/material/Avatar';
import { styled } from '@mui/material/styles';
import React from 'react';
import { u as useListItemAvatarContext } from '../../list-item-avatar-context-2ce6dab0.js';

var AvatarRoot = styled(MuiAvatar, {
    shouldForwardProp: function (propName) {
        return !['color', 'light', 'size'].includes(propName);
    },
})(function (_a) {
    var _b = _a.theme, componentsConfig = _b.componentsConfig, typography = _b.typography, palette = _b.palette, _c = _a.size, size = _c === void 0 ? 'medium' : _c, _d = _a.color, color = _d === void 0 ? 'primary' : _d, _e = _a.light, light = _e === void 0 ? false : _e;
    return (__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, typography.body2), { lineHeight: 1, width: componentsConfig.avatar.size.medium, height: componentsConfig.avatar.size.medium }), (size === 'small' && __assign(__assign({}, typography.caption), { lineHeight: 1, width: componentsConfig.avatar.size.small, height: componentsConfig.avatar.size.small }))), (size === 'large' && __assign(__assign({}, typography.body1), { lineHeight: 1, width: componentsConfig.avatar.size.large, height: componentsConfig.avatar.size.large }))), (color === 'default' && {
        backgroundColor: palette.grey[componentsConfig.avatar.bgColor],
    })), (color === 'primary' && __assign({ color: palette.primary.contrastText, backgroundColor: palette.primary.main }, (light && {
        color: palette.primary.main,
        backgroundColor: palette.primary.light,
    })))), (color === 'secondary' && __assign({ color: palette.secondary.contrastText, backgroundColor: palette.secondary.main }, (light && {
        color: palette.getContrastText(palette.secondary.light),
        backgroundColor: palette.secondary.light,
    })))), (color === 'success' && __assign({ color: palette.success.contrastText, backgroundColor: palette.success.main }, (light && {
        color: palette.success.main,
        backgroundColor: palette.success.light,
    })))), (color === 'warning' && __assign({ color: palette.warning.contrastText, backgroundColor: palette.warning.main }, (light && {
        color: palette.getContrastText(palette.warning.light),
        backgroundColor: palette.warning.light,
    })))), (color === 'info' && __assign({ color: palette.info.contrastText, backgroundColor: palette.info.main }, (light && {
        color: palette.getContrastText(palette.info.light),
        backgroundColor: palette.info.light,
    })))), (color === 'error' && __assign({ color: palette.error.contrastText, backgroundColor: palette.error.main }, (light && {
        color: palette.error.main,
        backgroundColor: palette.error.light,
    })))));
});
var Avatar = React.forwardRef(function AvatarComponent(_a, ref) {
    var propSize = _a.size, propChildren = _a.children, alt = _a.alt, restProps = __rest(_a, ["size", "children", "alt"]);
    var listItemAvatarContext = useListItemAvatarContext();
    var size = propSize || listItemAvatarContext.size;
    return (React.createElement(AvatarRoot, __assign({}, restProps, { size: size, ref: ref }), getChildren(propChildren, alt)));
});
function getChildren(children, alt) {
    if (children) {
        return children;
    }
    if (alt) {
        return getFallBack(alt);
    }
}
function getFallBack(alt) {
    var _a = alt.split(' '), _b = _a[0], firstPart = _b === void 0 ? '' : _b, _c = _a[1], secondPart = _c === void 0 ? '' : _c;
    return ((firstPart[0] || '').toUpperCase() + (secondPart[0] || '').toUpperCase());
}

export { Avatar as default };
